import { OcrProvisionKind, OcrProvisionStatus } from '@/types/schema';
import { FormsAnswerReview_EvidenceFragment } from '../graphql/FormSubmissions.generated';
type EvidenceStructure = NonNullable<FormsAnswerReview_EvidenceFragment['fileParagraphs']>[number]['ocrStructure'];

/** OCR numbering is a hypothesis, not a verified legal citation. */
export function formatEvidenceProvision(metadata: EvidenceStructure): string | undefined {
  if (!metadata || metadata.version !== 1) return undefined;
  const provision = metadata.inferredProvision;
  if (!provision || provision.parserVersion !== 1 || provision.status !== OcrProvisionStatus.Matched && provision.status !== OcrProvisionStatus.Continuation || !provision.path.length) return undefined;
  const labels: string[] = [];
  for (const item of provision.path) {
    if (!item.label.trim() || !Number.isInteger(item.paragraphIndex) || item.paragraphIndex < 0) return undefined;
    labels.push(item.label.trim());
  }

  // Old records can omit kinds. Do not infer classifications from label text.
  if (provision.path.some(item => !item.kind)) return labels.join(' ');
  let citation = '';
  for (const [index, item] of provision.path.entries()) {
    if (item.kind === OcrProvisionKind.Section && provision.path[index - 1]?.kind === OcrProvisionKind.Article) citation += ',';
    if (citation && (item.kind !== OcrProvisionKind.ListItem || provision.path[index - 1]?.kind === OcrProvisionKind.GenericHeading)) citation += ' ';
    const label = item.label.trim();
    citation += item.kind === OcrProvisionKind.Section ? `§ ${label}` : label;
  }
  return citation;
}